import React from 'react';

interface SectionTitleProps {
    title: string;
}

const SectionTitle: React.FC<SectionTitleProps> = (props) => {
    const { title } = props;
    return (
        <div className="v-center">
            <h2>{title}</h2>
        </div>
    );
};

export default SectionTitle;
